/**
 * 桥方法
 */

declare global {
  interface Window {
    WVJBCallbacks: any[];
    WebViewJavascriptBridge?: any;
  }
}

function setupWebViewJavascriptBridge(callback: (_: any) => void) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  document.addEventListener(
    'WebViewJavascriptBridgeReady'
    , function() {
      //do your work here
      callback(window.WebViewJavascriptBridge);
    },
    false
  );

  // if (window.WVJBCallbacks) {
  //   return window.WVJBCallbacks.push(callback);
  // }
  // window.WVJBCallbacks = [callback];
}

const ua = window.navigator.userAgent;

class Bridge {
  _isInApp = false;

  constructor() {
    this._isInApp = /ixxzh/.test(ua);
  }

  isInApp() {
    return this._isInApp;
  }

  async callBridgeMethod(name: string, args: any = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler(name, args, (str: any) => {
          console.log('bridge.callBridgeMethod res', str);
          resolve(str);
        });
      });
    });
  }

  callBridgeWithoutResponse(name: string, args: any = {}): void {
    setupWebViewJavascriptBridge((bridge) => {
      console.log('bridge.callBridgeWithoutResponse args', name, args);
      bridge.callHandler(name, args, (str: any) => {
        console.log('bridge.callBridgeWithoutResponse res', str);
      });
    });
  }

  async getXxzId() {
    if (!this._isInApp) {
      return null;
    }
    const str = await this.callBridgeMethod('getXxzhId');
    console.log('bridge.getXxzId result ', str);
    try {
      const res = JSON.parse(str);
      return res.xxzhId || '';
    } catch (err) {
      console.error('bridge.getXxzId error', err);
    }
    return '';
  }

  setWebviewTitle(title: string) {
    this.callBridgeWithoutResponse('setWebviewTitle', {
      title,
    });
  }

  // 调起支付宝支付
  async invokeAlipayForApp(orderInfo: string) {
    return new Promise((resolve, reject) => {
      window.WebViewJavascriptBridge.registerHandler("onAliPayResult", function(data: string) {
        console.log('bridge invokeAlipayForApp response data ', data);
        try {
          const out = JSON.parse(data);
          resolve(out);
        } catch (err) {
          reject(err);
        }
      });
      this.callBridgeWithoutResponse('toAliPay', {
        orderInfo,
      });
    });
  }

  // 语音口算APP里，调起微信支付
  async invokeWechatForApp(orderInfo: string) {
    return new Promise((resolve, reject) => {
      window.WebViewJavascriptBridge.registerHandler("onWxPayResult", function(data: string) {
        console.log('bridge invokeWechatForApp response data ', data);
        try {
          const out = JSON.parse(data);
          resolve(out);
        } catch (err) {
          reject(err);
        }
      });
      this.callBridgeWithoutResponse('toWxPay', orderInfo);
    });
  }

  // 在语音口算APP里，调起微信授权
  async invokeWechatAuthForApp() {
    return new Promise((resolve, reject) => {
      window.WebViewJavascriptBridge.registerHandler("setCode", function(data: string) {
        console.log('bridge toWxLogin response data ', data);
        try {
          const out = JSON.parse(data);
          resolve(out);
        } catch (err) {
          reject(err);
        }
      });
      this.callBridgeWithoutResponse('toWxLogin');
    });
  }

  /**
   * 更新native端本次存储的 userId xxzId
   * @param userId {string}
   * @param xxzId {string}
   */
  setIds(userId: string, xxzId: string) {
    this.callBridgeWithoutResponse('setIds', {
      userId,
      xxzId,
    });
  }
}

export const bridge = new Bridge();

(window as any).__bridge = bridge;

setupWebViewJavascriptBridge((bridge) => {
  bridge.init();
  console.log('bridge injected ');
});
